// extracted by mini-css-extract-plugin
export default {"root":"ToolCard_root__mnpyT"};